/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcFundingV1AccountNumberState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_FUNDING_V1_ACCOUNT_NUMBER_STATE_ENTITY_NAME = 'ixc.funding.v1.AccountNumber';
export const ixcFundingV1AccountNumberStateEntity = new schema.Entity<IxcFundingV1AccountNumberState>(IXC_FUNDING_V1_ACCOUNT_NUMBER_STATE_ENTITY_NAME, {}, { idAttribute: 'accountNumberId' });

